import * as React from "react";
import * as localizationLib from "@draftkings/sb-localization-lib";
import { PlayerMarketsRequestResolver } from "@draftkings/dk-data-layer";
import { getDefaultValue } from "@draftkings/sportsbook-common-utils";
import { marketBoardDict } from "./dict";
import { Marketboard } from "./ui";
import { MarketboardState } from "./state";
import { Condition, ConditionKeys, MarketboardParser, MarketboardRetriever } from "../../businessLayer";
import { getWebHeaders } from "./helpers";
import { GLOBAL_CLIENT_FETCH_TIMEOUT } from "./constants";
let mocks;
if (process.env.NODE_ENV === "development") {
    mocks = window["mocks"];
}
if (process.env.NODE_ENV === "test") {
    mocks = require("../../../../mocks/all");
}
export class MarketBoardRoot {
    constructor(options) {
        var _a;
        let playerMarketsRequestResolver = new PlayerMarketsRequestResolver({
            baseUrl: options.productConfig.dugoutBaseApiHost,
            requestTimeout: getDefaultValue(options.requestTimeout, GLOBAL_CLIENT_FETCH_TIMEOUT),
            consumerMetadata: getWebHeaders(options.consumerVersion),
        });
        if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") {
            // For development and test environments, we can use a mock resolver
            playerMarketsRequestResolver = new mocks.MarketBoard.PlayerMarketsRequestResolverMockPage({
                baseUrl: options.productConfig.dugoutBaseApiHost,
                requestTimeout: 10000,
            });
        }
        this.playerId = options.playerId;
        // Type was forced because localizationConfig is a required parameter for the component builder.
        // If undefined, the component builder applies its default LocalizationConfig.
        this.localizationConfig = options.localizationConfig;
        const condition = new Condition(ConditionKeys);
        this.dataProvider = new MarketboardState({
            dict: Object.assign(Object.assign({}, marketBoardDict), (((_a = options.localizationConfig) === null || _a === void 0 ? void 0 : _a.playerPage) || {})),
            condition,
            parser: new MarketboardParser({
                localizationLib,
                retriever: new MarketboardRetriever({
                    condition,
                    logError: options.consumerCommands.logError,
                    SubscribeToSportsbookPlayerEvents: options.dkDataLayer.SportsbookPlayerEvents,
                    playerMarketsRequestResolver,
                    trackEvent: options.trackEvent,
                    productConfig: options.productConfig
                }),
                oddsStyle: options.oddsStyle,
                expandedSubCategoriesByDefault: options.expandedSubCategoriesByDefault,
                consumerCommands: options.consumerCommands,
                betslipSelections: options.betslipSelections,
                playerPageLink: options.playerPageLink,
                productConfig: options.productConfig,
                isMobile: options.isMobile,
                onMobileToggleSelection: options.onMobileToggleSelection,
                trackEvent: options.trackEvent,
                featureFlags: options.featureFlags,
                logos: options.logos,
                s3AssetHost: options.s3AssetHost,
                localizationConfig: this.localizationConfig,
            }),
            headerAnimation: options.headerAnimation,
            playerImage: options.playerImage,
            playerPageError: options.playerPageError,
            playerPagePlaceholder: options.playerPagePlaceholder,
            milestonesComponentConfig: options.milestonesComponentConfig,
            productConfig: options.productConfig,
            trackEvent: options.trackEvent,
            getTeamLogo: options.getTeamLogo,
            isPlayerImageDisabled: options.isPlayerImageDisabled,
            tabSwitcherController: options.tabSwitcherController,
            messageBus: options.messageBus,
            localizationConfig: this.localizationConfig,
            locale: options.locale
        });
        this.component = React.createElement(Marketboard, Object.assign({}, { dataProvider: this.dataProvider }));
    }
    activateDataProvider() {
        this.dataProvider.activate();
        void this.dataProvider.loadData(`${this.playerId}`);
    }
    deactivate() {
        this.dataProvider.deactivate();
    }
    setOddsStyle(oddsStyle) {
        this.dataProvider.setOddsStyle(oddsStyle);
    }
    addSelections(data) {
        this.dataProvider.addSelections(data);
    }
    removeSelections(data) {
        this.dataProvider.removeSelections(data);
    }
    setParams(params) {
        this.dataProvider.setParams(params);
    }
}
//# sourceMappingURL=index.js.map